export enum ProcurementStatusEnum {
	Assigned = 1,
	Transit = 2,
	Delivered = 3,
	Invoiced = 4,
	Paid = 5,
	Open = 6,
	Manual = 7,
	Cancelled = 8,
	Closed = 9,
	Received = 10,
	PreQuote = 11,
	CancelProcess = 12,
	ReturnProcess = 13,
	Returned = 14,
	Transferred = 15,
	ReturnApprovalProcess = 16,
	WaitingRelease = 17,
	AwaitingPayment = 18,
	AwaitingApproval = 19,
}
